export enum JobNameDisplayOptionStatus {
    JobType = 0,
    ServiceAddress = 1,
    LocationName = 2,
    ServiceDate = 3,
}

export const getJobNameDisplay = (
    jobType: string | undefined,
    serviceAddress: string | undefined,
    locationName: string | undefined,
    serviceDate: string | undefined,
    jobNameDisplayOptions?: JobNameDisplayOptionStatus
): string | null => {
    if (jobNameDisplayOptions === undefined) {
        return null;
    }

    switch (jobNameDisplayOptions) {
        case JobNameDisplayOptionStatus.JobType:
            return jobType ?? null;
        case JobNameDisplayOptionStatus.ServiceAddress:
            return serviceAddress ?? null;
        case JobNameDisplayOptionStatus.LocationName:
            return locationName ?? null;
        case JobNameDisplayOptionStatus.ServiceDate:
            return serviceDate ?? null;
        default:
            return null;
    }
};
